module.exports = __webpack_public_path__ + "static/img/oops2.c1f01aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/10/oops2.png
// module id = qtuA
// module chunks = 1